var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionalFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6872 8.19355C22.6858 8.25365 22.6836 8.31375 22.6809 8.3735C23.3315 8.13191 24.0352 7.99987 24.7698 7.99987C28.0836 7.99987 30.7699 10.6862 30.7699 13.9999C30.7699 17.3137 28.0836 20 24.7698 20C24.7404 20 24.7109 19.9998 24.6816 19.9993C24.6596 19.999 24.6378 19.9986 24.616 19.9981V20H15.5152V10.7709L19.2477 14.55C19.5607 14.8669 20.0681 14.8669 20.3811 14.55C20.6942 14.2332 20.6942 13.7193 20.3811 13.4023L15.2804 8.23785C14.9674 7.92089 14.46 7.92089 14.147 8.23785L9.0463 13.4023C8.73345 13.7193 8.73345 14.2332 9.0463 14.55C9.35931 14.8669 9.86688 14.8669 10.1799 14.55L13.9122 10.7709V20H7.077V19.9985C3.15458 19.9165 0 16.7112 0 12.7694C0 8.82823 3.15318 5.62336 7.07436 5.54028C8.11213 2.32543 11.1292 0 14.689 0C19.1075 0 22.689 3.58175 22.689 8.00009C22.689 8.06482 22.6884 8.12938 22.6868 8.19377L22.6872 8.19355Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalFiles);
export default __webpack_public_path__ + "static/media/additionalFiles.b1ef42b0f1274dd4a1e9b36fb6e829ad.svg";
export { ForwardRef as ReactComponent };